import moment from 'moment-timezone';

window.moment = moment;

const isBetween = (start: number, ts: number, end: number) => start <= ts && ts <= end;

/* eslint-disable import/prefer-default-export */
export const generateDateRange = ({
  start,
  end,
  granularity = 'm',
  timelineDataDatePoints = [],
}: {
  start: string | number;
  end: string | number;
  granularity?: string;
  timelineDataDatePoints: number[],
}) => {
  // make sure all the important date points are in
  const startDate: number = moment(start).valueOf();
  const endDate: number = moment(end).valueOf();
  const dates: number[] = [];
  let date = startDate;
  while (date <= endDate) {
    dates.push(date);
    date = moment(date).add(1, granularity).valueOf();
  }
  dates.push(endDate);
  timelineDataDatePoints.forEach((d) => {
    if (isBetween(startDate, d, endDate)) {
      dates.push(d);
    }
  });

  return [...new Set(dates)].sort();
};
